export default {"src":"/_next/static/media/0x94b008aa00579c1307b0ef2c499ad98a8ce58e58.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};